<template>
  <b-container>
      <b-col>
      <dl class="row">
          <dt class="col-sm-3">Restriction Type</dt>
          <dd class="col-sm-9">{{restrictionType.description}}</dd>
      </dl>
    </b-col>
    <nav-tree v-if="!restrictionType.allowAllPlans" :items="groupedPlans"></nav-tree>       
  </b-container>
</template>

<script>
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {};
  },

  props: {
    plans: {
      type: Array,
      required: true
    },
    restrictionType: {
      type: Object,
      required: true
    }
  },
  computed: {
    groupedPlans: function() {
      return _.chain(this.plans)
        .groupBy(x => x.academicPlan.college.name)
        .map((value, key) => ({
          id: key,
          text: key,
          children: _.map(value, function(plan) {
            return {
              id: plan.academicPlanId,
              text: plan.academicPlan.description
            };
          })
        }))
        .value();
    }
  }
};
</script>

<style scoped>
</style>
